export default {
  direction: "row",
};
